<template>
	<v-card class="event-preview-card elevation-0 d-flex flex-column pb-1">
		<div class="event-preview-card__container">
			<div class="event-preview-card__outer">
				<div class="d-flex event-preview-card__list pl-0 pr-0">
					<div class="d-flex flex-column">
						<router-link
							:to="{ name: 'event-by-id', params: { id: this.event.event_id } }"
							class="text-decoration-none text--black"
						>
							<div
								v-if="!!event.event_image"
								class="event-preview-card__preview-image-container"
							>
								<img
									:src="event.event_image"
									alt="event-image-previw"
									class="event-preview-card__preview-image-container__preview-image"
								/>
								<div
									v-if="event.pin_to_top"
									class="event-preview-card__preview-image-container__pinned"
								>
									<Icon :size="16" type="pinned" />
								</div>
							</div>

							<div class="d-flex flex-column justify-space-around pa-3">
								<div class="event-preview-card__title mb-3">
									{{ event.event_title }}
								</div>

								<div class="event-preview-card__time-title mb-2 d-flex align-end">
									<Icon :size="16" type="union" color="var(--accent-color)" />
									<span class="ml-2">
										{{ event.dateTimePeriodToString }}
									</span>
								</div>

								<div
									class="event-preview-card__location d-flex align-end mb-2"
									v-if="event.address"
								>
									<Icon
										v-if="
											event.address.address_city ||
											event.address.address_state ||
											event.address.address_country
										"
										type="pin"
										color="var(--location-color)"
										:size="16"
										:pr="4"
									/>
									{{ getAddressLine(event.address) }}
								</div>
								<div v-if="event.tags.length">
									<v-chip
										v-for="(tag, index) in event.tags"
										:color="tag.tag_bg_color"
										:text-color="tag.tag_txt_color"
										class="post-preview-card__tag mr-2"
										:key="index"
									>
										#{{ tag.tag }}
									</v-chip>
								</div>
							</div>
						</router-link>

						<v-divider v-if="this.event.event_register_link" />
						<div
							v-if="this.event.event_register_link"
							class="event-preview-card__button-wrapper"
						>
							<a
								class="text-decoration-none"
								style="width: 100%"
								v-if="isExternal && !isFollowed"
								:href="event.event_register_link"
								target="_blank"
							>
								<button
									type="button"
									class="event-preview-card__button-wrapper__btn-register"
								>
									Register
								</button>
							</a>
							<button
								type="button"
								v-else-if="!isFollowed"
								class="event-preview-card__button-wrapper__btn-register"
								@click="onFollow"
							>
								Register
							</button>
							<button
								v-else
								type="button"
								class="event-preview-card__button-wrapper__btn-registered"
								@click="onFollow"
							>
								Registered
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</v-card>
</template>

<script>
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import pinnedIcon from '@/assets/images/icon-pinned.svg'
import bookmarkedIcon from '@/assets/images/postIcon/icon-bookmarked.svg'
import Dwh from '@/mixins/Dwh'
import ProfileBadge from '@/components/ProfileBadge.vue'
import { mapActions } from 'vuex'
import { followEvent, unfollowEvent } from '@/api/event'

Vue.use(VueScrollTo)

export default {
	name: 'EventPreview',
	components: {
		ProfileBadge,
	},
	mixins: [Dwh],
	props: {
		event: {
			type: Object,
			default: () => ({}),
		},
	},
	data() {
		return {
			isSchedule: 0,
			pinnedIcon,
			bookmarkedIcon,
			isFollowed: 0,
		}
	},
	watch: {
		event: {
			handler() {
				this.isFollowed = this.event.follow
			},
			immediate: true,
		},
	},
	computed: {
		isExternal() {
			return this.event.event_register_link.startsWith('http')
		},
	},

	methods: {
		...mapActions('event', ['addEventToSchedule', 'removeEventFromSchedule']),
		getAddressLine(address) {
			return [address.address_city, address.address_state, address.address_country]
				.filter(function (v) {
					return v !== null
				})
				.join(',')
		},
		handleRegisterEvent() {
			this.sendTrigger({
				category: 'Content',
				action: 'click_register_button_event',
				module: 'Events',
				data: this.event.event_id,
				title: this.event.event_title,
				content_chapter_id: this.event.chapter_id ? [this.event.chapter_id] : null,
			})
		},
		onFollow() {
			if (this.isFollowed) {
				unfollowEvent(this.event.event_id)
			} else if (!this.isFollowed) {
				followEvent({ event_id: this.event.event_id })
				this.handleRegisterEvent()
			}

			this.isFollowed = !this.isFollowed
		},
	},
	created() {
		if (this.event) {
			this.isSchedule = this.event.schedule
		}
	},
}
</script>

<style lang="scss">
.event-preview-card {
	background: #f1f1f1 !important;
	font-family: Inter, sans-serif;
	color: rgb(74, 74, 74);
	&__button-wrapper {
		padding: 12px;
		display: flex;
		width: 100%;
		&__btn-register {
			display: flex;
			width: 100%;
			justify-content: center;
			align-items: center;
			border: 1.5px solid #9b9b9b;
			height: 46px;
			border-radius: 8px;
			font-family: Inter, sans-serif;
			font-weight: 700;
			font-size: 18px;
			line-height: 100%;
			letter-spacing: 0;
			text-align: center;
			background-color: var(--accent-color) !important;
			color: #ffffff;
		}
		&__btn-registered {
			display: flex;
			width: 100%;
			justify-content: center;
			align-items: center;
			border: 1.5px solid var(--accent-color);
			height: 46px;
			border-radius: 8px;
			font-family: Inter, sans-serif;
			font-weight: 700;
			font-size: 18px;
			line-height: 100%;
			letter-spacing: 0;
			text-align: center;
			background-color: #ffffff;
			color: var(--accent-color);
		}
	}

	&__container {
		width: 100%;
		height: 100%;
		border-radius: 10px !important;
		background: white !important;
	}

	&__brief-description {
		font-family: 'Inter', sans-serif;
		font-size: 14px;
		line-height: 17.07px;
		font-weight: 400;
	}

	&__content-inner {
		color: rgb(74, 74, 74);
		font-size: 15px;
		font-family: Inter, sans-serif;
		font-weight: normal;
		line-height: 18px;

		img {
			width: 100%;
		}

		p {
			margin-bottom: 0;
		}

		h1 {
			font-size: 30px;
			padding-bottom: 8px;
			line-height: 30px;
		}
	}
	&__preview-image-container {
		width: 100%;
		height: 100%;
		position: relative;
		border-radius: 8px;
		padding: 12px;
		&__pinned {
			position: absolute;
			top: 20px;
			right: 20px;
			width: 32px;
			height: 32px;
			border-radius: 8px;
			border: 1px solid #e2e2e2;
			background-color: #ffffff;
			display: flex;
			align-items: center;
			justify-content: center;
		}
		&__preview-image {
			width: 100%;
			max-height: 325px;
			object-fit: cover;
			border-radius: 8px;
		}
	}

	&__location {
		display: flex;
		color: var(--location-color);
		font-family: Inter, sans-serif;
		font-weight: 500;
		font-size: 13px;
		line-height: 100%;
		letter-spacing: 0;
	}

	&__meta {
		font-family: Inter, sans-serif;
		font-style: normal;
		font-weight: bold;
		font-size: 18px;
		line-height: 20px;
		color: rgb(66, 160, 216);
		letter-spacing: 0.36px;
		gap: 4px;

		&-bottom {
			color: rgb(155, 155, 155);
			font-size: 16px;
			font-family: Inter, sans-serif;
			font-weight: normal;
			line-height: 16px;

			span {
				min-width: 85px;
			}
		}

		&-time {
			color: rgb(155, 155, 155);
			font-size: 12px;
			font-family: Inter, sans-serif;
			font-weight: normal;
			text-align: right;
		}
	}

	&__avatar {
		img {
			object-fit: cover;
		}
	}

	&__outer {
		border-radius: 8px !important;
		border: 1px solid #e2e2e2 !important;
	}

	&__list {
		flex-direction: column;
	}

	&__link {
		color: var(--button-main-background-color);
		font-size: 16px;
		font-family: Montserrat, sans-serif;
		font-weight: bold;

		a {
			color: var(--button-main-background-color) !important;
		}
	}

	&__title {
		color: var(--accent-color) !important;
		font-family: Inter, sans-serif;
		font-weight: 700;
		font-size: 20px;
		line-height: 22px;
		letter-spacing: 0;
		a {
			color: #202232 !important;
			text-decoration: none;
		}
	}
	&__time-title {
		font-family: Inter, sans-serif;
		font-weight: 400;
		font-size: 13px;
		line-height: 100%;
		letter-spacing: 0;
		color: #4a4a4a;
	}
	&__block-view {
		flex-direction: column;
		height: 73%;

		.post-preview-card__thumbnail-outer img {
			max-width: 100%;
		}
	}

	&__content {
		font-family: Montserrat;
		font-style: normal;
		font-weight: 500;
		font-size: 16px;
		line-height: 21px;
	}

	&__thumbnail {
		height: auto;
		width: 100%;
		max-height: 143px;
	}

	&__tag {
		padding: 6px;
		border-radius: 3px !important;
		color: rgb(74, 74, 74);
		font-size: 14px !important;
		font-family: Montserrat, sans-serif;
		font-weight: normal;
		height: 20px !important;
		cursor: pointer;

		&:hover {
			color: #fff !important;
			background-color: rgb(66, 160, 216) !important;
		}
	}

	&__like-button {
		font-family: Montserrat, sans-serif;
		font-style: normal;
		font-weight: 500;
		font-size: 13px;
		line-height: 16px;
		color: #aaaaaa;

		&-active {
			color: #db7842 !important;
		}

		.theme--light.v-icon:focus::after {
			opacity: 0;
		}
	}

	&__share-button {
		font-family: Montserrat, sans-serif;
		font-style: normal;
		font-weight: 500;
		font-size: 13px;
		line-height: 16px;
		color: #aaaaaa !important;
		cursor: pointer;

		.v-icon {
			transform: rotateY(180deg);
		}

		&:hover {
			span {
				color: #757575;
				text-decoration: underline;
			}
		}
	}

	&__book-button {
		color: var(--accent-color);
		font-size: 14px;
		font-family: Montserrat, sans-serif;
		font-weight: bold;
		text-decoration: underline;

		&-active {
			color: #0a00a5 !important;
		}

		.theme--light.v-icon:focus::after {
			opacity: 0;
		}
	}

	&__comment {
		color: rgb(74, 74, 74);
		font-size: 15px;
		font-family: Montserrat, sans-serif;
		font-weight: normal;
		letter-spacing: -0.43px;
		width: 100%;

		&::placeholder {
			color: rgb(160, 160, 160);
			font-size: 15px;
			font-family: Montserrat, sans-serif;
			font-weight: normal;
			letter-spacing: -0.43px;
		}

		&:focus {
			outline: none;
		}

		&-send {
			width: 38px;
			height: 22px;
			color: rgb(160, 160, 160);
			font-size: 14px;
			font-family: Montserrat, sans-serif;
			font-weight: bold;
			text-decoration: underline;
			cursor: pointer;
		}
	}

	&__comments-button {
		font-family: Montserrat, sans-serif;
		font-style: normal;
		font-weight: 500;
		font-size: 13px;
		line-height: 16px;
		display: flex;
		align-items: flex-end;
		color: #aaaaaa;
		cursor: pointer;

		&:hover {
			span {
				color: #757575;
				text-decoration: underline;
			}
		}
	}

	&__my-menu {
		margin-top: 20px;
		min-width: 175px !important;
		contain: initial !important;
		overflow: visible !important;

		&:before {
			content: '';
			position: absolute;
			left: 14px;
			top: 0;
			z-index: -1;
			border-radius: 3px;
			transform: translate(0, -50%) rotate(45deg);
			width: 20px;
			height: 20px;
			background: #fff;
			box-shadow: 0 0 11px rgb(0 0 0 / 14%);
		}
	}

	&__menu-dots {
		margin-left: 10px !important;
	}

	@media screen and (max-width: 1904px) {
		&__block {
			flex: 0 0 100%;
		}
		&__list {
			flex: 0 0 75%;
		}
	}
	@media screen and (max-width: 1264px) {
		&__block {
			flex: 0 0 100%;
		}
		&__list {
			flex: 0 0 66%;
		}
	}

	@media screen and (min-width: 1264px) {
		&__container {
			max-width: 600px;
		}
	}
	@media screen and (max-width: 768px) {
		&__thumbnail {
			max-height: 250px;
			height: 100%;
			max-width: 100%;
		}
		&__default-thumbnail {
			max-height: 250px;
			height: 100%;
		}
		&__outer {
			flex-direction: column;
		}
	}
}

.dropdown-profile {
	padding: 15px;

	&__item {
		min-height: 30px !important;
		padding: 0;
	}

	&__title {
		color: #aaaaaa;
		font-size: 12px !important;
		line-height: 1.4 !important;
		font-family: 'Montserrat', sans-serif !important;
		font-weight: 600 !important;
	}

	&__title:hover {
		text-decoration: underline;
		color: black;
		transition: color 0.2s, background-color 0.2s, border-color 0.2s !important;
	}
}
</style>
